export default {"src":"/_next/static/media/Logomark (4).5f940941.svg","height":44,"width":36,"blurWidth":0,"blurHeight":0};